import { useRoutes } from 'react-router-dom'
import { HomePage } from '../Pages/Home/HomePage'
import { Profile } from '../Pages/Profiler/profile'
import { UserPage } from '../Pages/Users/User'
import { PrivateRoute } from './PrivateRoute'
import { ProductsPage } from '../Pages/Products'
import { ProductsNew } from '../Pages/Products/products-new'
import { MarcaPage } from '../Pages/Marca'
import { MarcaNew } from '../Pages/Marca/marca-new'
import { GrupoPage } from '../Pages/Grupo'
import { GrupoNew } from '../Pages/Grupo/grupo-new'
import { UnidadeMedidaPage } from '../Pages/Unidades_Medida'
import { UnidadeMedidaNew } from '../Pages/Unidades_Medida/unidadeMedida-new'
import { TributacaoPage } from '../Pages/Tributacao'
import { TributacaoNew } from '../Pages/Tributacao/tributacao-new'
import { EmpresaPage } from '../Pages/Empresas/empresas-list'
import { EmpresaNewPage } from '../Pages/Empresas/empresa-new'
import { FornecedorPage } from '../Pages/Fornecedor'
import { FornecedorNew } from '../Pages/Fornecedor/fornecedor-new'
import { TransportadoraPage } from '../Pages/Transportadora'
import { TransportadoraNew } from '../Pages/Transportadora/transportadora-new'
import { ClientesPage } from '../Pages/Clientes'
import { ClienteNew } from '../Pages/Clientes/cliente-new'
import { LancaAcertoEstoque } from '../Pages/Estoque/lanca-acerto'
import { FormaPagtoPage } from '../Pages/FormaPagamento'
import { FormaPagtoNew } from '../Pages/FormaPagamento/formaPagamento-new'
import { SubGrupoPage } from '../Pages/SubGrupo'
import { SubGrupoNew } from '../Pages/SubGrupo/subGrupo-new'
import { NaturezaOperacaoPage } from '../Pages/NaturezaOperacao'
import { NaturezaOperacaoNew } from '../Pages/NaturezaOperacao/naturezaOperacao-new'
import { MovimentacaoEstoque } from '../Pages/Estoque/movimentacao-estoque'
import { EntradaNotaPage } from '../Pages/NotasEntrada'
import { SaidaNotaPage } from '../Pages/NotasSaida'
import { ConfigNFPage } from '../Pages/ConfigNF/config-nf'
import { SerieDocPage } from '../Pages/Serie_Doc_Fiscal'
import { SerieDocNew } from '../Pages/Serie_Doc_Fiscal/serieDoc-new'
import { GrupoDepesaPage } from '../Pages/GrupoDespesa'
import { GrupoDespesaNew } from '../Pages/GrupoDespesa/grupoDespesa-new'
import { SubGrupoDepesaPage } from '../Pages/SubGrupoDespesa'
import { SubGrupoDespesaNew } from '../Pages/SubGrupoDespesa/subGrupoDespesa-new'
import { LancamentoContaAPagar } from '../Pages/ContasAPagar/contaAPagar-new'
import { ContaAPagarPage } from '../Pages/ContasAPagar'
import { ParceirosNewPage } from '../Pages/Parceiros/parceiros-new'
import { ParceiroPage } from '../Pages/Parceiros/parceiros'
import { ContaAPagarExcluidas } from '../Pages/ContasAPagar/contaAPagar-excluidas'
import { ClientesExcluidas } from '../Pages/Clientes/cliente-excluidas'
import { ProdutosExcluidos } from '../Pages/Products/products-excluidos'
import { ContasPage } from '../Pages/Contas'
import { ContaNew } from '../Pages/Contas/contas-new'
import { ContaExcluidas } from '../Pages/Contas/contas-excluidas'
import { ContaAPagarRelatorios } from '../Pages/ContasAPagar/contaAPagar-relatorioDia'
import { MarcaExcluidos } from '../Pages/Marca/marca-excluidos'
import { GrupoExcluidos } from '../Pages/Grupo/grupo-excluidos'
import { SubGrupoExcluidos } from '../Pages/SubGrupo/subGrupo-excluidos'
import { LanctoCaixaPage } from '../Pages/ControleContas/LanctoControleContasPage'
import { NaturezaOperacaoExcluidos } from '../Pages/NaturezaOperacao/naturezaOperacao-excluidos'
import { UnidadeMedidaExcluidos } from '../Pages/Unidades_Medida/unidadeMedida-excluidos'
import { FormaPagtoExcluidos } from '../Pages/FormaPagamento/formaPagamento-excluidos'
import { TributacaoExcluidos } from '../Pages/Tributacao/tributacao-excluidos'
import { FornecedorExcluidos } from '../Pages/Fornecedor/fornecedor-excluidos'
import { GrupoDespesaExcluidos } from '../Pages/GrupoDespesa/grupoDespesa-excluidos'
import { SubGrupoDespesaExcluidos } from '../Pages/SubGrupoDespesa/subGrupoDespesaExcluido'
import { TransportadoraExcluidos } from '../Pages/Transportadora/transportadora-excluidos'
import { SerieDocExcluidos } from '../Pages/Serie_Doc_Fiscal/serieDoc-excluidos'
import { ExtratoContasPage } from '../Pages/ControleContas/ExtratoContasPage'
import { LancaVendas } from '../Pages/Vendas/lanca-venda'
import { RelatorioVendasPorPeriodo } from '../Pages/Vendas/relatorio-vendas-periodo'
import { RelatorioItensVendas } from '../Pages/Vendas/relatorio-vendas-itens'
import { RelatorioVendasItensCliente } from '../Pages/Vendas/relatorio-vendas-itens-clientes'
import { TransferenciasPage } from '../Pages/ControleContas/TransferenciasPage'
import { LanctoChequePage } from '../Pages/ControleCheques/lancaControleCheque'
import { ChequesPage } from '../Pages/ControleCheques'
import { ContaAReceberPage } from '../Pages/ContasAReceber'
import { ContaAReceberExcluidas } from '../Pages/ContasAReceber/contaAReceber-excluidas'
import { LancamentoContaAReceber } from '../Pages/ContasAReceber/contaAReceber-new'
import { ContaAReceberRelatorios } from '../Pages/ContasAReceber/contaAReceber-relatorioDia'
import { ContaAReceberRecibos } from '../Pages/ContasAReceber/contaAReceber-recibos'
import { ConsultarVendas } from '../Pages/Vendas/consultarVenda'
import { SupSangria } from '../Pages/SupSangria/sup-sangria'
import { RelCaixaDiario } from '../Pages/Caixa/rel-caixa-diario'
import { LancaVendasCondicional } from '../Pages/Vendas/lanca-vendas-condicional'
import { CadastroEmpresaCliente } from '../Pages/empresa_cad/cadastro-empresa'
import { UserCreatePassword } from '../Pages/Login/user-create-password'
import { RelatorioEstoqueProduto } from '../Pages/Estoque/products-relatorio-estoque'
import { UserRememberPassword } from '../Pages/Login/user-remember-password'
import { BandeiraNew } from '../Pages/Bandeira/bandeira-new'
import { BandeirasPage } from '../Pages/Bandeira'
import { BandeirasExcluidas } from '../Pages/Bandeira/bandeira-excluidas'
import { LancamentoCartaoPage } from '../Pages/LancamentoCartao'
import { LancamentoCartaoNew } from '../Pages/LancamentoCartao/lanctoCartao-new'
import { LanctoChequeExcluidas } from '../Pages/ControleCheques/lancaControleCheque-excluidas'
import { LanctoCartaoExcluidos } from '../Pages/LancamentoCartao/lanctoCartao-excluidas'
import { LandingPage } from '../Pages/Home/LandingPage'

const Rotas = () => {
    return useRoutes([
        { path: '/', element: <PrivateRoute><HomePage /></PrivateRoute> },

        { path: '/cliente',                     element: <PrivateRoute><ClientesPage /></PrivateRoute> },
        { path: '/cliente/new',                 element: <PrivateRoute><ClienteNew /></PrivateRoute> },
        { path: '/cliente/edit/:idCliente',     element: <PrivateRoute><ClienteNew /></PrivateRoute> },
        { path: '/cliente/excluidos',           element: <PrivateRoute><ClientesExcluidas /></PrivateRoute> },

        { path: '/produtos',                    element: <PrivateRoute><ProductsPage /></PrivateRoute> },
        { path: '/produtos/new',                element: <PrivateRoute><ProductsNew /></PrivateRoute> },
        { path: '/produtos/edit/:idProd',       element: <PrivateRoute><ProductsNew /></PrivateRoute> },
        { path: '/produtos/dupli/:idProdDup',   element: <PrivateRoute><ProductsNew /></PrivateRoute> },
        { path: '/produtos/excluidos',          element: <PrivateRoute><ProdutosExcluidos /></PrivateRoute> },

        { path: '/marca',                   element: <PrivateRoute><MarcaPage /></PrivateRoute> },
        { path: '/marca/new',               element: <PrivateRoute><MarcaNew /></PrivateRoute> },
        { path: '/marca/edit/:idmarca',     element: <PrivateRoute><MarcaNew /></PrivateRoute> },
        { path: '/marca/excluidos',         element: <PrivateRoute><MarcaExcluidos /></PrivateRoute> },

        { path: '/companies',                    element: <PrivateRoute><EmpresaPage /></PrivateRoute> },
        { path: '/companies/new',                element: <PrivateRoute><EmpresaNewPage /></PrivateRoute> },
        { path: '/companies/edit/:idCompany',    element: <PrivateRoute><EmpresaNewPage /></PrivateRoute> },

        { path: '/grupo',               element: <PrivateRoute><GrupoPage /></PrivateRoute> },
        { path: '/grupo/new',           element: <PrivateRoute><GrupoNew /></PrivateRoute> },
        { path: '/grupo/edit/:idgrup',  element: <PrivateRoute><GrupoNew /></PrivateRoute> },
        { path: '/grupo/excluidos',     element: <PrivateRoute><GrupoExcluidos /></PrivateRoute> },

        { path: '/subGrupo',                    element: <PrivateRoute><SubGrupoPage /></PrivateRoute> },
        { path: '/subGrupo/new',                element: <PrivateRoute><SubGrupoNew /></PrivateRoute> },
        { path: '/subGrupo/edit/:idsubGrup',    element: <PrivateRoute><SubGrupoNew /></PrivateRoute> },
        { path: '/subGrupo/excluidos',          element: <PrivateRoute><SubGrupoExcluidos /></PrivateRoute> },

        { path: '/naturezaOperacao',                            element: <PrivateRoute><NaturezaOperacaoPage /></PrivateRoute> },
        { path: '/naturezaOperacao/new',                        element: <PrivateRoute><NaturezaOperacaoNew /></PrivateRoute> },
        { path: '/naturezaOperacao/edit/:idnaturezaOperacao',   element: <PrivateRoute><NaturezaOperacaoNew /></PrivateRoute> },
        { path: '/naturezaOperacao/excluidos',                  element: <PrivateRoute><NaturezaOperacaoExcluidos /></PrivateRoute> },

        { path: '/unidMedida',                  element: <PrivateRoute><UnidadeMedidaPage /></PrivateRoute> },
        { path: '/unidMedida/new',              element: <PrivateRoute><UnidadeMedidaNew /></PrivateRoute> },
        { path: '/unidMedida/edit/:idUnid',     element: <PrivateRoute><UnidadeMedidaNew /></PrivateRoute> },
        { path: '/unidMedida/excluidos',        element: <PrivateRoute><UnidadeMedidaExcluidos /></PrivateRoute> },

        { path: '/formaPagto',                      element: <PrivateRoute><FormaPagtoPage /></PrivateRoute> },
        { path: '/formaPagto/new',                  element: <PrivateRoute><FormaPagtoNew /></PrivateRoute> },
        { path: '/formaPagto/edit/:idFormaPagto',   element: <PrivateRoute><FormaPagtoNew /></PrivateRoute> },
        { path: '/formaPagto/excluidos',            element: <PrivateRoute><FormaPagtoExcluidos /></PrivateRoute> },

        { path: '/tributacao',                      element: <PrivateRoute><TributacaoPage /></PrivateRoute> },
        { path: '/tributacao/new',                  element: <PrivateRoute><TributacaoNew /></PrivateRoute> },
        { path: '/tributacao/edit/:idTrib',         element: <PrivateRoute><TributacaoNew /></PrivateRoute> },
        { path: '/tributacao/dupli/:idTribDup',     element: <PrivateRoute><TributacaoNew /></PrivateRoute> },
        { path: '/tributacao/excluidos',            element: <PrivateRoute><TributacaoExcluidos /></PrivateRoute> },

        { path: '/fornecedor',                  element: <PrivateRoute><FornecedorPage /></PrivateRoute> },
        { path: '/fornecedor/new',              element: <PrivateRoute><FornecedorNew /></PrivateRoute> },
        { path: '/fornecedor/edit/:idForn',     element: <PrivateRoute><FornecedorNew /></PrivateRoute> },
        { path: '/fornecedor/excluidos',        element: <PrivateRoute><FornecedorExcluidos /></PrivateRoute> },

        { path: '/grupoDespesa',                    element: <PrivateRoute><GrupoDepesaPage /></PrivateRoute> },
        { path: '/grupoDespesa/new',                element: <PrivateRoute><GrupoDespesaNew /></PrivateRoute> },
        { path: '/grupoDespesa/edit/:idgDespesa',   element: <PrivateRoute><GrupoDespesaNew /></PrivateRoute> },
        { path: '/grupoDespesa/excluidos',          element: <PrivateRoute><GrupoDespesaExcluidos /></PrivateRoute> },

        { path: '/sgrupoDespesa',                       element: <PrivateRoute><SubGrupoDepesaPage /></PrivateRoute> },
        { path: '/sgrupoDespesa/new',                   element: <PrivateRoute><SubGrupoDespesaNew /></PrivateRoute> },
        { path: '/sgrupoDespesa/edit/:idSGrupoDesp',    element: <PrivateRoute><SubGrupoDespesaNew /></PrivateRoute> },
        { path: '/sgrupoDespesa/excluidos',             element: <PrivateRoute><SubGrupoDespesaExcluidos /></PrivateRoute> },

        { path: '/transportadora',                      element: <PrivateRoute><TransportadoraPage /></PrivateRoute> },
        { path: '/transportadora/new',                  element: <PrivateRoute><TransportadoraNew /></PrivateRoute> },
        { path: '/transportadora/edit/:idTransporte',   element: <PrivateRoute><TransportadoraNew /></PrivateRoute> },
        { path: '/transportadora/excluidos',            element: <PrivateRoute><TransportadoraExcluidos /></PrivateRoute> },

        { path: '/serieDoc',                           element: <PrivateRoute><SerieDocPage /></PrivateRoute> },
        { path: '/serieDoc/new',                       element: <PrivateRoute><SerieDocNew /></PrivateRoute> },
        { path: '/serieDoc/edit/:idSerie',             element: <PrivateRoute><SerieDocNew /></PrivateRoute> },
        { path: '/serieDoc/excluidos',                 element: <PrivateRoute><SerieDocExcluidos /></PrivateRoute> },

        { path: '/parceiros',                       element: <PrivateRoute><ParceiroPage /></PrivateRoute> },
        { path: '/parceiros/new',                   element: <PrivateRoute><ParceirosNewPage /></PrivateRoute> },
        { path: '/parceiros/edit/:id_parceiro',     element: <PrivateRoute><ParceirosNewPage /></PrivateRoute> },

        { path: '/contas',                          element: <PrivateRoute><ContasPage /></PrivateRoute> },
        { path: '/contas/new',                      element: <PrivateRoute><ContaNew /></PrivateRoute> },
        { path: '/contas/edit/:idConta',            element: <PrivateRoute><ContaNew /></PrivateRoute> },
        { path: '/contas/excluidos',                element: <PrivateRoute><ContaExcluidas /></PrivateRoute> },

        { path: '/estoque_acerto',                  element: <PrivateRoute><LancaAcertoEstoque /></PrivateRoute> },
        { path: '/estoque_movimentacao',            element: <PrivateRoute><MovimentacaoEstoque /></PrivateRoute> },
        { path: '/estoque',                         element: <PrivateRoute><LancaAcertoEstoque /></PrivateRoute> },
        { path: '/rel_estoque_produto',             element: <PrivateRoute><RelatorioEstoqueProduto /></PrivateRoute> },
        { path: '/configNF',                        element: <PrivateRoute><ConfigNFPage /></PrivateRoute> },

        { path: '/entradaNota',                     element: <PrivateRoute><EntradaNotaPage /></PrivateRoute> },
        { path: '/saidaNota',                       element: <PrivateRoute><SaidaNotaPage /></PrivateRoute> },

        { path: '/contaApagar',                     element: <PrivateRoute><ContaAPagarPage /></PrivateRoute> },
        { path: '/contaApagar/new',                 element: <PrivateRoute><LancamentoContaAPagar /></PrivateRoute> },
        { path: '/contaApagar/edit/:idDupPagar',    element: <PrivateRoute><LancamentoContaAPagar /></PrivateRoute> },
        { path: '/contaApagar/excluidos',           element: <PrivateRoute><ContaAPagarExcluidas /></PrivateRoute> },
        { path: '/contaApagar/relatorios',          element: <PrivateRoute><ContaAPagarRelatorios /></PrivateRoute> },

        { path: '/contaAreceber',                   element: <PrivateRoute><ContaAReceberPage /></PrivateRoute> },
        { path: '/contaAreceber/new',               element: <PrivateRoute><LancamentoContaAReceber /></PrivateRoute> },
        { path: '/contaAreceber/edit/:idDupReceber',element: <PrivateRoute><LancamentoContaAReceber /></PrivateRoute> },
        { path: '/contaAreceber/excluidos',         element: <PrivateRoute><ContaAReceberExcluidas /></PrivateRoute> },
        { path: '/contaAreceber/relatorios',        element: <PrivateRoute><ContaAReceberRelatorios /></PrivateRoute> },
        { path: '/contaAreceber/recibos',           element: <PrivateRoute><ContaAReceberRecibos /></PrivateRoute> },

        { path: '/bandeira',                        element: <PrivateRoute><BandeirasPage /></PrivateRoute> },
        { path: '/bandeira/new',                    element: <PrivateRoute><BandeiraNew /></PrivateRoute> },
        { path: '/bandeira/edit/:idBandeira',       element: <PrivateRoute><BandeiraNew /></PrivateRoute> },
        { path: '/bandeira/excluidos',              element: <PrivateRoute><BandeirasExcluidas /></PrivateRoute> },  

        { path: '/lanctoCartao',                        element: <PrivateRoute><LancamentoCartaoPage /></PrivateRoute> },
        { path: '/lanctoCartao/new',                    element: <PrivateRoute><LancamentoCartaoNew /></PrivateRoute> },
        { path: '/lanctoCartao/edit/:idLanctoCartao',   element: <PrivateRoute><LancamentoCartaoNew /></PrivateRoute> },
         { path: '/lanctoCartao/excluidos',             element: <PrivateRoute><LanctoCartaoExcluidos /></PrivateRoute> },

        { path: '/login',                           element: <LandingPage /> },
        //{ path: '/landingPage',                     element: <LandingPage /> },

        { path: '/User/CreatePassword',             element: <UserCreatePassword/>},
        { path: '/User/RememberPassword',           element: <UserRememberPassword/>},
        { path: '/Empresa',                         element: <CadastroEmpresaCliente /> },
        { path: '/profile',                         element: <Profile /> },
        { path: '/user',                            element: <UserPage /> }, 

        { path: '/c_contas_new',                    element: <PrivateRoute><LanctoCaixaPage /></PrivateRoute> }, 
        { path: '/c_contas_transferencia',          element: <PrivateRoute><TransferenciasPage /></PrivateRoute> },
        { path: '/c_contas_extrato',                element: <PrivateRoute><ExtratoContasPage /></PrivateRoute> },

        { path: '/c_cheque',                        element: <PrivateRoute><ChequesPage /></PrivateRoute> },
        { path: '/c_cheque/new',                    element: <PrivateRoute><LanctoChequePage /></PrivateRoute> },
        { path: '/c_cheque/edit/:idDoCheque',       element: <PrivateRoute><LanctoChequePage /></PrivateRoute> },
        { path: '/c_cheque/excluidos',              element: <PrivateRoute><LanctoChequeExcluidas /></PrivateRoute> },

        { path: '/sup_sangria',                     element: <PrivateRoute><SupSangria /></PrivateRoute> },
        { path: '/rel_caixa_diario',                element: <PrivateRoute><RelCaixaDiario /></PrivateRoute> },

        { path: '/venda',                                      element: <PrivateRoute><LancaVendas /></PrivateRoute> },
        { path: '/venda/edit/:idDaVenda',                       element: <PrivateRoute><LancaVendas /></PrivateRoute> },
        { path: '/venda/condicional/:idDaVenda',                element: <PrivateRoute><LancaVendasCondicional /></PrivateRoute> },
        { path: '/venda/consulta',                              element: <PrivateRoute><ConsultarVendas /></PrivateRoute> },
        { path: '/relatorios_venda',                            element: <PrivateRoute><RelatorioVendasPorPeriodo /></PrivateRoute> },
        { path: '/relatorios_itens',                            element: <PrivateRoute><RelatorioItensVendas /></PrivateRoute> },
        { path: '/relatorios_resumo_vendas',                    element: <PrivateRoute><RelatorioVendasItensCliente /></PrivateRoute> },

        // ROTA 404 (catch-all)
        //{ path: '*', element: <Navigate to="/" replace /> }
        { path: '*', element: <PrivateRoute replace={true}><HomePage/></PrivateRoute> },                
    ])
}

export default Rotas;

